import { SES_CONCLUIR_PREENCHIMENTO_SUCESSO, SES_CONCLUIR_PREENCHIMENTO_TODAS_SUCESSO, SES_CURRENT_STEP_WIZARD, SES_LOADING, SES_SET_PRAZO_PREENCHIMENTO_AUTODECLARACAO_VENCIDO_SUCESSO, SES_SET_PREENCHIMENTO_AUTODECLARACAO_CONCLUIDO_SUCESSO, SES_SET_TAREFA_REQUER_AUTODECLARACAO_SUCESSO, SES_SHOW_FORM_DADOS_SEGURADO, SES_SHOW_FORM_DECLARACAO } from "./actionTypes";

const INITIAL_STATE = {
  showModal: false,
  currentStepWizard: 0,
  erros: [],
  interessadoTarefaSES: null,
  aceiteFinalizarRequerimentoJaInformado: false,
  municipiosConsulta: [],
  showFormDeclaracao: false,
  preenchimentoAutodeclaracaoConcluido: false,
  prazoPreenchimentoAutodeclaracaoVencido: false,
  tarefaRequerAutoDeclaracao: false,
  showFormDadosSegurado: false,
  statusTarefa: null,
  loading: false
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case SES_CURRENT_STEP_WIZARD: {
      return {
        ...state,
        currentStepWizard: action.payload
      };
    }
    case SES_SHOW_FORM_DECLARACAO: {
      return {
        ...state,
        showFormDeclaracao: action.payload
      };
    }
    case SES_SET_PREENCHIMENTO_AUTODECLARACAO_CONCLUIDO_SUCESSO: {
      return {
        ...state,
        preenchimentoAutodeclaracaoConcluido: action.payload
      };
    }
    case SES_SET_PRAZO_PREENCHIMENTO_AUTODECLARACAO_VENCIDO_SUCESSO: {
      return {
        ...state,
        prazoPreenchimentoAutodeclaracaoVencido: action.payload
      };
    }
    case SES_SET_TAREFA_REQUER_AUTODECLARACAO_SUCESSO: {
      return {
        ...state,
        tarefaRequerAutoDeclaracao: action.payload
      };
    }
    case SES_CONCLUIR_PREENCHIMENTO_SUCESSO: {
      return {
        ...state,
        preenchimentoAutodeclaracaoConcluido: true
      };
    }
    case SES_SHOW_FORM_DADOS_SEGURADO: {
      return {
        ...state,
        showFormDadosSegurado: action.payload
      };
    }
    case SES_LOADING: {
      return {
        ...state,
        loading: action.payload
      };
    }
    case SES_CONCLUIR_PREENCHIMENTO_TODAS_SUCESSO: {
      return {
        ...state,
        statusTarefa: action.payload,
        preenchimentoAutodeclaracaoConcluido: true,
      };
    }
    default:
      return state;
  }
};
